import React, { useState } from 'react';
import { FiMapPin, FiMail, FiPhone, FiInstagram, FiLinkedin, FiSend } from 'react-icons/fi';
import { FaWhatsapp, FaTelegram } from 'react-icons/fa6';
import Reveal from './fx/Reveal';

const Contact = () => {
    const [form, setForm] = useState({
        name: '',
        position: '',
        company: '',
        service: 'Cybersecurity Training & Labs',
        message: '',
    });

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = (e) => {
        e.preventDefault();
        const fullMsg = `Hello, I'm ${form.name} (${form.position}) from ${form.company}.\n\nI'd like to ask about ${form.service}.\n\n${form.message}`;
        const encodedMsg = encodeURIComponent(fullMsg);
        window.open(`https://wa.me/6281234868640?text=${encodedMsg}`, '_blank');
    };

    return (
        <section id="contact" className="relative bg-[#05060a] text-white px-6 md:px-16 py-24 overflow-hidden">
            <div className="absolute -left-32 -bottom-20 w-[500px] h-[500px] rounded-full bg-red-700/10 blur-3xl pointer-events-none" />
            <div className="relative max-w-7xl mx-auto">
                <Reveal className="text-center mb-14">
                    <span className="pill tag inline-flex mb-4">CONTACT</span>
                    <h2 className="font-display text-4xl md:text-5xl font-bold">
                        Get in <span className="text-gradient-red">touch</span>
                    </h2>
                    <p className="text-gray-400 mt-3 max-w-2xl mx-auto text-lg">
                        Ready to enhance your cybersecurity? Reach out and we'll respond within one business day.
                    </p>
                </Reveal>

                <div className="grid md:grid-cols-2 gap-10 items-start">
                    <Reveal>
                        <form onSubmit={handleSubmit} className="grid gap-4 card p-6">
                            <input type="text" name="name" placeholder="Full Name" value={form.name} onChange={handleChange} required
                                className="bg-black/30 text-white p-3 rounded-lg border border-white/10 focus:outline-none focus:border-red-500 transition" />
                            <input type="text" name="position" placeholder="Your Position" value={form.position} onChange={handleChange}
                                className="bg-black/30 text-white p-3 rounded-lg border border-white/10 focus:outline-none focus:border-red-500 transition" />
                            <input type="text" name="company" placeholder="Company / Institution" value={form.company} onChange={handleChange}
                                className="bg-black/30 text-white p-3 rounded-lg border border-white/10 focus:outline-none focus:border-red-500 transition" />
                            <select name="service" value={form.service} onChange={handleChange}
                                className="bg-black/30 text-white p-3 rounded-lg border border-white/10 focus:outline-none focus:border-red-500 transition">
                                <option>Cybersecurity Training & Labs</option>
                                <option>CTF / Cyber Exercise Event</option>
                                <option>Red Teaming & Penetration Testing</option>
                                <option>Akademi Siber</option>
                                <option>Others</option>
                            </select>
                            <textarea name="message" placeholder="Message" value={form.message} onChange={handleChange} required rows="5"
                                className="bg-black/30 text-white p-3 rounded-lg border border-white/10 focus:outline-none focus:border-red-500 transition" />
                            <button type="submit" className="btn-primary justify-center">
                                Send via WhatsApp <FiSend />
                            </button>
                        </form>
                    </Reveal>

                    <Reveal delay={120}>
                        <div className="card p-6">
                            <h3 className="font-display text-xl font-semibold mb-5">Contact Information</h3>
                            <div className="space-y-5">
                                <Info
                                    icon={<FiMapPin />}
                                    title="Office"
                                    body={
                                        <>
                                            Sovereign Plaza Lantai 12<br />
                                            Jl. TB Simatupang No. 36<br />
                                            Jakarta Selatan, Indonesia
                                        </>
                                    }
                                />
                                <Info icon={<FiMail />} title="Email" body="admin@siberlab.id" />
                                <Info icon={<FiPhone />} title="Phone / WhatsApp" body="+62 812 3486 8640" />
                            </div>
                            <div className="mt-6 pt-6 border-t border-white/10">
                                <h4 className="font-semibold mb-3">Follow Us</h4>
                                <div className="flex gap-3">
                                    <Social href="https://t.me/siberlabid"><FaTelegram /></Social>
                                    <Social href="https://wa.me/6281234868640"><FaWhatsapp /></Social>
                                    <Social href="https://www.instagram.com/siberlab.id"><FiInstagram /></Social>
                                    <Social href="http://www.linkedin.com/in/siberlab.id"><FiLinkedin /></Social>
                                </div>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
};

const Info = ({ icon, title, body }) => (
    <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-lg bg-red-500/10 border border-red-500/30 flex items-center justify-center text-red-400">
            {icon}
        </div>
        <div>
            <h4 className="font-semibold text-white">{title}</h4>
            <p className="text-gray-400">{body}</p>
        </div>
    </div>
);

const Social = ({ href, children }) => (
    <a href={href} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-lg bg-white/5 hover:bg-red-500/20 border border-white/10 hover:border-red-500/40 flex items-center justify-center transition">
        {children}
    </a>
);

export default Contact;
